import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { StoreModule } from '@ngrx/store'
import { StoreKeysEnum } from '../../../store/store-keys'
import { headerReducer } from './state/header.reducers'
import { EffectsModule } from '@ngrx/effects'
import { HeaderEffects } from './state/header.effects'
import { HeaderComponent } from './header.component'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { NgClickOutsideDirective } from 'ng-click-outside2'
import { LoadingModule } from '../../../shared/ui/loading/loading.module'
import { PerfectScrollbarModule } from '../../../shared/ui/perfect-scrollbar/perfect-scrollbar.module'
import { DisplayDatePipeModule } from '../../../shared/pipes/display-date.pipe.module'
import { OrderByPipeModule } from '../../../shared/pipes/order-by-pipe.module'
import { BulkOperationAnnouncementsModule } from '../bulk-operation-announcements/bulk-operation-announcements.module'
import { MainPipesModule } from '../pipes/main-pipes.module'
import { DirectivesUpgradedModule } from '../../../shared/directives/directivesUpgraded.module'

@NgModule({
    imports: [
        StoreModule.forFeature(StoreKeysEnum.HeaderComponent, headerReducer),
        EffectsModule.forFeature([HeaderEffects]),
        CommonModule,
        RouterModule,
        FormsModule,
        NgClickOutsideDirective,
        LoadingModule,
        PerfectScrollbarModule,
        DisplayDatePipeModule,
        OrderByPipeModule,
        BulkOperationAnnouncementsModule,
        MainPipesModule,
        DirectivesUpgradedModule,
    ],
    declarations: [
        HeaderComponent,
    ],
    exports: [
        HeaderComponent,
    ]
})
export class HeaderModule {}